import React, { memo } from "react";
import { EventTypeV2 } from "@onair/repositories";
import StepInfo from "./step-info";
import StepTimelineAndPricing from "./step-timeline-and-pricing";
import StepTimeline from "./step-timeline";
import StepResource from "./step-resource";
import StepPricing from "./step-pricing";
import { Box } from "@mui/material";
import { WizardSchemaType } from ".";
import { UseFormReturn } from "react-hook-form";

interface StepFormWizardProps {
	activeStep: number;
	stepType: EventTypeV2;
	methods: UseFormReturn<WizardSchemaType>;
	stepNavigator: React.ReactNode;
}

const StepFormWizard: React.FC<StepFormWizardProps> = ({
	activeStep,
	stepType,
	methods,
	stepNavigator,
}) => {
	return (
		<Box>
			{activeStep === 0 && (
				<StepInfo methods={methods} navigator={stepNavigator} />
			)}
			{activeStep === 1 && (
				<>
					{stepType === EventTypeV2.SINGLE ? (
						<StepTimelineAndPricing
							methods={methods}
							navigator={stepNavigator}
						/>
					) : (
						<StepTimeline methods={methods} navigator={stepNavigator} />
					)}
				</>
			)}
			{activeStep === 2 && (
				<>
					{stepType === EventTypeV2.SINGLE ? (
						<StepResource methods={methods} navigator={stepNavigator} />
					) : (
						<StepPricing methods={methods} navigator={stepNavigator} />
					)}
				</>
			)}
			{activeStep === 3 && (
				<>
					{stepType === EventTypeV2.SESSION && (
						<StepResource methods={methods} navigator={stepNavigator} />
					)}
				</>
			)}
		</Box>
	);
};

export default memo(StepFormWizard);
